<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <div style="display: flex">
          <div class="sample-image">
            <el-image
              :src="
                formData.displayImageUrl
                  ? $osscdn(formData.displayImageUrl)
                  : '/image/static/img/nopic.jpg'
              "
              :fit="'cover'"
              :preview-src-list="[
                formData.displayImageUrl
                  ? $osscdn(formData.displayImageUrl)
                  : '/image/static/img/nopic.jpg',
              ]"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 337px; height: 224px"
                />
              </div>
            </el-image>
            <div class="expoinfo-name">
              {{ formData.expoInfoName }}
            </div>
          </div>
          <div style="min-height: 224px; flex: 1; margin-left: 22px">
            <SapmleInfo :data="formData" />
          </div>
        </div>
      </el-col>

      <el-col :span="24" class="mt-2">
        <div style="display: flex">
          <div style="width: 337px">
            <CommentsCard
              :selectionCode="formData.selectionCode"
              :expoMeetingCode="formData.expoMeetingCode"
              recordType="P"
              ref="commentsCardRef"
            />
          </div>
          <div
            style="
              width: 700px;
              flex: 1;
              margin-left: 22px;
              margin-top: 27px;
              position: relative;
            "
          >
            <QuotedInfo
              :quotedInfo="formData"
              :disabled="disabled"
              ref="quotedInfoRefs"
              @reload="getData"
            ></QuotedInfo>
            <div style="position: absolute; bottom: 0; right: 0">
              <el-button
                @click="save"
                size="small"
                type="primary"
                v-if="!disabled"
                >{{ $l('INDEX.btn_save') || '保存' }}</el-button
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import SapmleInfo from './sapmle-info'
import CommentsCard from './comments-card'
import QuotedInfo from './quoted-info'
export default {
  mixins: [EditLoading],
  components: { SapmleInfo, CommentsCard, QuotedInfo },
  props: {
    disabled: { type: Boolean, default: false },
    tskInfoCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      localTimeZone: '',
    }
  },
  watch: {
    tskInfoCode: {
      handler(value) {
        if (value) {
          this.getData()
        }
      },
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      if (!this.tskInfoCode) return
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .personalTskQuotedGoodsDetailApi({
          tskInfoCode: this.tskInfoCode,
          localTimeZone,
        })
        .catch(() => null)
      console.log(res)
      this.formData = res?.body || {}
      if (!res?.body) {
        return
      }
      await this.$refs.commentsCardRef.fetchData()
      await this.$refs.quotedInfoRefs.getData()
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    async save() {
      await this.$refs.quotedInfoRefs.save()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.sample-image {
  // width: 100%;
  // height: 100%;
  width: 337px;
  height: 224px;
  aspect-ratio: 3 / 2;
  position: relative;
  display: flex;
  justify-content: center;
  border: 1px #f1f1f2 solid;
  // align-items: center;
  .expoinfo-name {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.2);
    color: rgba(96, 98, 102, 1);
    text-align: center;
    padding: 8rpx 0;
  }
}
</style>
